import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../ToastContext';
import { getAll } from '../../../../pages/_request';
import { ITemplateClaimDto } from '../../../../interfaces/IUtilities';
import BaseSelect from '../Select/BaseSelect';

interface TemplateClaimDropdownProps {
    value: ITemplateClaimDto | null;
    onChange: (templateClaim: ITemplateClaimDto) => void;
}

type Option = { value: string; label: string };

const TemplateClaimDropdown: React.FC<TemplateClaimDropdownProps> = ({ value, onChange }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [templateClaims, setTemplateClaims] = useState([] as ITemplateClaimDto[]);

    const fetchTemplateClaims = async () => {
        try {
            let params = ``;
            let results = await getAll('/api/templateclaims/getall-nofilters', params);
            let respStatus = results?.status || results?.response.status;

            if (respStatus === 200) {
                let dataResults = results?.data as ITemplateClaimDto[];
                setTemplateClaims(dataResults);
            } else {
                showToast(t('StatusCode', { code: String(respStatus) }), 'error');
                throw new Error(t('StatusCode', { code: String(respStatus) }));
            }
        } catch (error) {
            console.log(t('ConnectionError', { error: String(error) }));
            showToast(t('ConnectionError', { error: String(error) }), 'error');
            showToast(t('PredefinedTemplateClaimsFailed', { error: String(error) }), 'error');
        }
    };

    useEffect(() => {
        fetchTemplateClaims();
    }, []);

    const options: Option[] = templateClaims.map((tc) => ({ value: tc.id, label: tc.name }));

    const selectedOption: Option | null = value ? { value: value.id, label: value.name } : null;

    const handleChange = (option: any) => {
        if (!option) return;
        const selected = templateClaims.find((tc) => tc.id === option.value);
        if (selected) onChange(selected);
    };

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            minWidth: '250px',
            width: '100%',
        }),
        menu: (provided: any) => ({
            ...provided,
            minWidth: '250px',
            width: '100%',
        }),
        option: (provided: any) => ({
            ...provided,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div className="gg-dropdown-templateclaim" style={{ minWidth: '250px' }}>
            <BaseSelect
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isDisabled={templateClaims.length === 0}
                styles={customStyles}
                placeholder={t('SelectPredefinedTemplateClaim')}
            />
        </div>
    );
};

export default TemplateClaimDropdown;
